import { useMemo } from 'react';

import { MergeTag } from 'domains/content/types';
import { getFriendlyName } from 'utils';

const useFormatSmsContent = (content: string, mergeTags: MergeTag[]) =>
    useMemo(() => {
        if (!content || typeof content !== 'string') {
            return 'Start typing to see a live preview of your message here!';
        }

        const regex = /{{.*?}}/g;
        const matches = content.match(regex);

        if (matches && mergeTags?.length) {
            let formattedContent = content;

            for (const match of matches) {
                const mergeTag = mergeTags.find((tag) => tag.value === match);
                if (mergeTag) {
                    formattedContent = formattedContent.replaceAll(
                        match,
                        mergeTag.previewValue || `[${getFriendlyName(mergeTag.name)}]`
                    );
                }
            }

            return formattedContent;
        }

        return content;
    }, [content, mergeTags]);

export default useFormatSmsContent;
